import axios from 'axios'
import Promise from 'es6-promise'
import {setToken, getToken, removeToken} from '@/utils/auth'
import store from '@/store'
import { SET_AUTH_USER_STATUS } from '@/store/modules/auth/mutation-types'
import { PermissionChecker } from '../permission-checker'
import {
  CONST_HEADER,
  CONST_RACE_WHITE_LISTS,
  jumpToLogin,
  noShowDefaultCodeError,
  MIRROR_MANAGE_LIST,
} from './default'
import { IS_DAYANCLOUD } from '../../utils/const'

const permissionChecker = new PermissionChecker()
// const prod = process.env.NODE_ENV === 'production'

/**
 * request should carry with cookies
 */
axios.defaults.withCredentials = true
axios.Promise = window.Promise = window.Promise || Promise

axios
    .interceptors
    .request
    .use(config => {
      Object.assign(config.headers, { 'Content-Type': 'application/json' }, CONST_HEADER())
      const url = config.url
      if (MIRROR_MANAGE_LIST.includes(url)) {
        Object.assign(config.headers, {
          platform: window.location.host.includes('admin.renderbus.com') ? 64 : 62,
        })
      }
      if (!permissionChecker.checkRequest(url)) {
        console.log('permission deny')
        throw new axios.Cancel('permission deny')
      }
      return config
    }, (error) => {
      return Promise.reject(error)
    })
/**
 * cancel calling apis which are in race conditions
 */
let pendingApiList = new Map()
const cancelRaceApi = (url) => {
  if (pendingApiList.has(url)) {
    const cancel = pendingApiList.get(url)
    cancel(url)
    pendingApiList.delete(url)
  }
}
axios.interceptors.request.use(config => {
  if (!CONST_RACE_WHITE_LISTS.includes(config.url)) {
    const url = config.url
    if (!config.isCancelRaceApi) {
      cancelRaceApi(url)
      config.cancelToken = new axios.CancelToken(cancel => {
        if (!pendingApiList.has(url)) {
          pendingApiList.set(url, cancel)
        }
      })
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
axios.interceptors.response.use(response => {
  if (!CONST_RACE_WHITE_LISTS.includes(response.config.url)) {
    cancelRaceApi(response.config.url)
  }
  return response
}, (error) => {
  return Promise.reject(error)
})

axios
    .interceptors
    .response
    .use(({data, headers, config}) => {
      /* eslint-disable */
      // x-auth-token是记录登录装态的
      if (headers['x-auth-token'] && headers['x-auth-token'] !== getToken()) {
        setToken(headers['x-auth-token'])
      }
      if (/(602|401|405)$/.test(data.code)) {
        removeToken()
        store.commit(`auth/${SET_AUTH_USER_STATUS}`, false)
        jumpToLogin()
        return Promise.reject()
      }
      if (!data.BlocksExchange && data.code !== 200) {
        const reachedGiftLimit = 977 // 赠送额度达到上限
        let existedCode = [900, 901, 902, 615, 622, 1002, 619, 623, 624, 978, 620, 1150, 1023, 5056, 980, 982, 981, 713, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1302, 1303, 1304, 1340, 0, 700, 1311, 1312, 5073, 5074, 5075, 5076, 5077, 5078, 731, 732, 507, 508, 513, 733, 714, 715, 734, 736, 737, 735, 631, 612, 1332, 1333, 1395, 1396, 1397, 1418, 1035, 1904]
        if (IS_DAYANCLOUD) {
          existedCode = [...existedCode, 836]
        }
        const hideRequestIdCode = [719, 720, 726, 727, 984, 701, 617, 700, 785, 992, 1801, 1802, 1803, 1804, 1805, 1806, 1807, 1808, 1809, 1903] // 719禁用平台操作 720全局搜索禁用平台任务号
        /**
         * 以下相应码不弹出错误信息框
         * 900（手机号已存在)
         * 901（邮箱已存在）
         * 902（用户名已存在）
         * 700 (图片加载失败)
         * 622 获取临时密码问题不提示
         * 623 包含不存在用户ID
         * 624 不支持子账号ID
         * 978 支付订单号重复
         * 620 主账号设置总额度超过允许设置的最大额度
         * 1023 删除软件判断存在关联插件
         * 5056 新增软件版本已存在
         * 713 该用户有欠费，不允许删除
         * 1302,1303,1304 兑奖券码错误提示
         * 0 添加节点时提示在其他机房存在
         * 731 默认平台已存在
         * 732 效果图区不可设置为动画区默认平台
         */
        if (data.code === reachedGiftLimit) {
          const message = vm.$t(`api_${data.code}`, [data.data.limit])
          vm.$message({
            message: data.requestId ? message + ` requestId : ${data.requestId}` : vm.$t(`api_${data.code}`),
            type: 'error'
          })
        } else if (noShowDefaultCodeError(data.code, config.url)) {
          // Break out
        } else if(hideRequestIdCode.includes(data.code)) {
          vm.$message({
            message: vm.$t(`api_${data.code}`),
            type: 'error'
          })
        } else if(existedCode.indexOf(data.code) === -1) {
          vm.$message({
            message: data.requestId ? vm.$t(`api_${data.code}`) + ` requestId : ${data.requestId}` : vm.$t(`api_${data.code}`),
            type: 'error'
          })
        }
      }
      return data
    }, (error) => {
      /* eslint-disable */
      if(!error.message.match(/code\s\d+/)) {
        return Promise.reject(error)
      }
      const code = error.message.match(/code\s\d+/)[0].match(/\d+/)[0]
      console.log(error.message)
      let requestId = ''
      if (error.response) requestId = error.response.data.requestId
      vm.$message({
        message: requestId ? vm.$t(`api_${code}`) + ` requestId : ${requestId}` : vm.$t(`api_${code}`),
        type: 'error'
      })
      return Promise.reject(error)
    })
